module.exports = __webpack_public_path__ + "static/logoSinFondo2-62cf14b3108244c470b76b91049ddcc4.png";